import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Row,
  Col,
  Layout,
  Select,
  Checkbox,
  Space,
  Spin,
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditorComponent from "components/Common/Quill";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

function Chapter({filterP, filterHandler}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [originData, setOriginData] = useState([]);
  const [languageGroup, setLanguageGroup] = useState([]);
  const [cefr, setCefr] = useState({})
  const [groups, setGroups] = useState([]);
  const [courses, setCourses] = useState([]);
  const [stages, setStages] = useState([])
  const [curLanguage, setCurLanguage] = useState("L0010");
  const [fixLanguage, setFixLanguage] = useState(false);
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [sourceDataNative, setSourceDataNative] = useState([]);
  const [editPopup, setEditPopup] = useState([false, {}]);
  const [insertPopup, setInsertPopup] = useState([false, ""]);
  const [preNext, setPreNext] = useState([false, false]);
  const [rowIndex, setRowIndex] = useState(null);
  const [codeDisible, setCodeDisible] = useState(true);
  const [codesControll, setCodesControll] = useState([false, false]);
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false)

  const [rightBox, setRightBox] = useState([false, {}]);
  const [rightBoxPreNext, setRightBoxPreNext] = useState([false, false]);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [100, 200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
  });
  const [filter, setFilter] = useState({
    group: filterP.group,
    course: filterP.course,
    stage: filterP.stage
  });
  const [insertFilter, setInsertFilter] = useState({
    group: "all",
    course: "all",
    stage: "all"
  });

  const formRef = useRef({});
  const rightFormRef = useRef(null);

  const columns = [
    {
      title: "스테이지",
      dataIndex: "groupInfo",
      key: "groupInfo",
      width: "300px",
    },
    {
      title: "챕터 코드",
      dataIndex: "code",
      key: "code",
      width: "120px",
    },
    {
      title: "챕터 제목(한국어)",
      dataIndex: "name",
      key: "name",
      width: "250px",
    },
    {
      title: "A1",
      dataIndex: "cefr_a1_yn",
      key: "cefr_a1_yn",
      width: "60px",
      render: (_, record) => (
        <Checkbox
          className="cefr_a1_yn"
          defaultChecked={_ === "Y" ? true : false}
          checked={_ === "Y" ? true : false}
          onChange={(e)=>{cefrChangerByTable(e,record)}}
          disabled={record.course_a1 === "Y" ? false : true}
        />
      ),
    },
    {
      title: "A2",
      dataIndex: "cefr_a2_yn",
      key: "cefr_a2_yn",
      width: "60px",
      render: (_, record) => (
        <Checkbox
        className="cefr_a2_yn"
          defaultChecked={_ === "Y" ? true : false}
          checked={_ === "Y" ? true : false}
          onChange={(e)=>{cefrChangerByTable(e,record)}}
          disabled={record.course_a2 === "Y" ? false : true}
        />
      ),
    },
    {
      title: "B1",
      dataIndex: "cefr_b1_yn",
      key: "cefr_b1_yn",
      width: "60px",
      render: (_, record) => (
        <Checkbox
        className="cefr_b1_yn"
          defaultChecked={_ === "Y" ? true : false}
          checked={_ === "Y" ? true : false}
          onChange={(e)=>{cefrChangerByTable(e,record)}}
          disabled={record.course_b1 === "Y" ? false : true}
        />
      ),
    },
    {
      title: "B2",
      dataIndex: "cefr_b2_yn",
      key: "cefr_b2_yn",
      width: "60px",
      render: (_, record) => (
        <Checkbox
        className="cefr_b2_yn"
          defaultChecked={_ === "Y" ? true : false}
          checked={_ === "Y" ? true : false}
          onChange={(e)=>{cefrChangerByTable(e,record)}}
          disabled={record.course_b2 === "Y" ? false : true}
        />
      ),
    },
    {
      title: "C1",
      dataIndex: "cefr_c1_yn",
      key: "cefr_c1_yn",
      width: "60px",
      render: (_, record) => (
        <Checkbox
        className="cefr_c1_yn"
          defaultChecked={_ === "Y" ? true : false}
          checked={_ === "Y" ? true : false}
          onChange={(e)=>{cefrChangerByTable(e,record)}}
          disabled={record.course_c1 === "Y" ? false : true}
        />
      ),
    },
    {
      title: "C2",
      dataIndex: "cefr_c2_yn",
      key: "cefr_c2_yn",
      width: "60px",
      render: (_, record) => (
        <Checkbox
        className="cefr_c2_yn"
          defaultChecked={_ === "Y" ? true : false}
          checked={_ === "Y" ? true : false}
          onChange={(e)=>{cefrChangerByTable(e,record)}}
          disabled={record.course_c2 === "Y" ? false : true}
        />
      ),
    },
    {
      title: "유닛 갯수",
      dataIndex: "count",
      key: "count",
      width: "110px",
    },
    {
      title: "처리",
      dataIndex: "",
      width:"150px",
      render: (_, record) => (
        <div>
          <a
            style={{ margin: "0px 5px" }}
            onClick={(e) => {
              e.stopPropagation();
              const plusNum =
                (tableParams.pagination.current - 1) *
                tableParams.pagination.pageSize;

              if (rightBox[0]) {
                setRightBox([false, {}]);
              }

              if (sourceDataKor.length === 1) {
                setPreNext([true, true]);
              } else if (_.num === 0) {
                setPreNext([true, false]);
              } else if (_.num === sourceDataKor.length - 1) {
                setPreNext([false, true]);
              }

              setRowIndex(_.num - plusNum);
              setInsertFilter({
                ...insertFilter,
                group: _.ContentCourseGroup_code,
                course: _.ContentCourse_code,
                stage: _.ContentStage_code
              });

              setEditPopup([true, _]); // reset해도 값을 유지하기 위함
            }}
          >
            수정
          </a>
          <a
            style={{ margin: "0px 5px" }}
            onClick={(e) => {
              e.stopPropagation();
              deleteHandler(_);
            }}
          >
            삭제
          </a>
        </div>
      ),
    },
    {}
  ];

  const getSourceData = (data) => {
    const filteredData = data.data[0].filter((ele) => {
      const groupFilter =
        filter.group === "all" || filter.group === ele.ContentCourseGroup_code
          ? true
          : false;

      const courseFilter =
        filter.course === "all" || filter.course === ele.ContentCourse_code
          ? true
          : false;

      const stageFilter =
        filter.stage === "all" || filter.stage === ele.ContentStage_code
          ? true
          : false;

      return groupFilter && courseFilter && stageFilter;
    });

    const data1 = JSON.parse(JSON.stringify(filteredData));
    const data2 = JSON.parse(JSON.stringify(filteredData));

    const kor = data1.map((ele, idx) => {
      ele.num = idx;
      ele.name = null;
      ele.learning_points = null;
      ele.groupInfo = null;
      ele.SystemSettingLanguage_code = "L0010";
      for (let i = 0; i < data.data[1].length; i++) {
        if (
          ele.code === data.data[1][i].code &&
          data.data[1][i].SystemSettingLanguage_code === "L0010"
        ) {
          ele.name = data.data[1][i].name;
          ele.learning_points = data.data[1][i].learning_points;
          ele.SystemSettingLanguage_code =
            data.data[1][i].SystemSettingLanguage_code;
          if (
            idx === 0 || //그룹코드를 연속으로 표시하지 않기 위한 코드
            ele.ContentStage_code !== data1[idx - 1].ContentStage_code
          ) {
            ele.groupInfo = `${ele.ContentStage_code} ${ele.ContentStage_name}`;
          }
          break;
        }
      }
      return ele;
    });

    const native = data2.map((ele, idx) => {
      ele.num = idx;
      ele.name = null;
      ele.learning_points = null;
      ele.SystemSettingLanguage_code = curLanguage;
      for (let i = 0; i < data.data[1].length; i++) {
        if (
          ele.code === data.data[1][i].code &&
          data.data[1][i].SystemSettingLanguage_code === curLanguage
        ) {
          ele.name = data.data[1][i].name;
          ele.learning_points = data.data[1][i].learning_points;
          ele.SystemSettingLanguage_code =
            data.data[1][i].SystemSettingLanguage_code;
          break;
        }
      }
      return ele;
    });
    const languages = data.data[2].map((el) => {
      return { label: el.name_kor, value: el.code };
    });
    setOriginData(data.data);
    setLanguageGroup(languages);
    setSourceDataKor(kor);
    setSourceDataNative(native);
    // setTableParams({
    //   ...tableParams,
    //   pagination: {
    //     ...tableParams.pagination,
    //     total: kor.length, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
    //   },
    // });
  };

  const groupFilter = (value) => {
    setRowIndex(null);
    setRightBox([false, {}]);
    setFilter({ ...filter, group: value, course: "all", stage: "all" });
    filterHandler({
      group: value,
      course: "all",
      stage: "all",
      chapter: "all",
      unit: "all",
      subUnit: "all",
    })
        setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  };

  const courseFilter = (value) => {
    setRowIndex(null);
    setRightBox([false, {}]);
    setFilter({ ...filter, course: value, stage: "all" });
    filterHandler({
      group: filterP.group,
      course: value,
      stage: "all",
      chapter: "all",
      unit: "all",
      subUnit: "all",
    })
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  };

  const stageFilter = (value) => {
    setRowIndex(null);
    setRightBox([false, {}]);
    setFilter({ ...filter, stage: value });
    filterHandler({
      group: filterP.group,
      course: filterP.course,
      stage: value,
      chapter: "all",
      unit: "all",
      subUnit: "all",
    })
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  };

  const cefrChanger = (e) => { // 등록 화면에서의 핸들러
    const { id, checked } = e.target;
    formRef.current.setFieldValue(id, checked ? "Y" : "N");
  };

  const cefrChangerEdit = (e) => { // 수정화면에서의 핸들러
    const { id, checked } = e.target;
    const data = { ...editPopup[1] };
    data[id] = checked ? "Y" : "N";
    setEditPopup([true, data]);
    formRef.current.setFieldValue(id, checked ? "Y" : "N");
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const data = fixLanguage ? sourceDataNative : sourceDataKor;
    const newNum =
      pagination.current * pagination.pageSize - pagination.pageSize;

    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (rightBox[0]) {
      setRowIndex(0);
      setCurLanguage(data[newNum].SystemSettingLanguage_code);
      setRightBox([true, data[newNum]]);
      if (newNum === 0) {
        setRightBoxPreNext([true, false]);
      } else if (newNum === data.length - 1) {
        setRightBoxPreNext([false, true]);
      } else {
        setRightBoxPreNext([false, false]);
      }
      rightFormRef.current.setFieldsValue(data[newNum]);
    } else {
      setRowIndex(null);
    }
  };

  const insertCodes = async () => {
    const value = await formRef.current.validateFields();
    console.log(value);

    let val = true;
    for (let i = 0; i < originData[0].length; i++) {
      const code = originData[0][i].ContentStage_code;
      if (code === value.ContentStage_code) {
        val = false;
        break;
      }
    }

    if (!val) {
      Modal.error({
        style: { whiteSpace: "pre-line" },
        title: "챕터코드 일괄생성 에러",
        content: `선택한 스테이지에는 챕터가 등록되어 있습니다.
        일괄생성하기 위하여는 기존에 등록되어 있는 챕터를 먼저 삭제해주세요.`,
        okText: "확인",
      });
    } else {
      axios
        .post(`${backend}/contents/content_structure/chapter/insert_codes`, {
          value,
        })
        .then((data) => {
          getSourceData(data.data);
          setCodesControll([false, false]);
          formRef.current.resetFields();
          setInsertFilter({ group: "all", course: "all", stage: "all" });
          Modal.success({
            title: "일괄생성 완료",
            okText: "확인",
            content: "정상적으로 생성되었습니다.",
          });
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            navigate("/auth");
          } else {
            Modal.error({
              title: "오류",
              okText: "확인",
              content:
                "서버에 문제가 있어 등록작업을 진행할 수 없습니다. 관리자에게 문의하세요.",
            });
          }
        });
    }
  };

  const deleteCodes = async () => {
    const value = await formRef.current.validateFields();
    // console.log(value)
    let val = true;
    for (let i = 0; i < originData[0].length; i++) {
      const code = originData[0][i].ContentStage_code;
      const count = originData[0][i].count;
      if (code === value.ContentStage_code && count !== 0) {
        val = false;
        break;
      }
    }

    if (!val) {
      Modal.error({
        style: { whiteSpace: "pre-line" },
        title: "챕터 일괄삭제 에러",
        content:
          `선택한 스테이지에 속한 챕터에 유닛이 등록되어 있습니다.
          일괄삭제하기 위하여는 기존에 등록되어 있는 유닛을 먼저 삭제해주세요.`,
        okText: "확인",
      });
    } else {
      axios
        .post(`${backend}/contents/content_structure/chapter/delete_codes`, {
          value,
        })
        .then((data) => {
          getSourceData(data.data);
          setCodesControll([false, false]);
          formRef.current.resetFields();
          setInsertFilter({ group: "all", course: "all", stage: "all" });
          Modal.success({
            title: "일괄삭제 완료",
            okText: "확인",
            content: "정상적으로 삭제되었습니다.",
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            navigate("/auth");
          }
          console.log(err);
          Modal.error({
            title: "오류",
            okText: "확인",
            content:
              "서버에 문제가 있어 등록작업을 진행할 수 없습니다. 관리자에게 문의하세요.",
          });
        });
    }
  };

  const insertHandler = () => {
    editCancelHandlerRight();
    setCodeDisible(true);
    setInsertFilter(filter)
    axios
      .get(`${backend}/contents/content_structure/chapter/newcode`)
      .then((data) => {
        const newCode = "CH" + ("0000000" + String(data.data.data)).slice(-7);

        setInsertPopup([true, newCode]);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        }
        console.log(err);
        Modal.error({
          title: "오류",
          okText: "확인",
          content:
            "서버에 문제가 있어 등록작업을 진행할 수 없습니다. 관리자에게 문의하세요.",
        });
      });
    // setInsertPopup([true,""])
  };

  const insertOkHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .post(`${backend}/contents/content_structure/chapter/insert`, { value })
      .then((data) => {
        if (data.status === 210) {
          Modal.error({
            style: { whiteSpace: "pre-line" },
            title: "에러",
            content: data.data.message,
            okText: "확인",
          });
        } else {
          getSourceData(data.data);
          setInsertPopup([false, ""]);
          formRef.current.resetFields();
          setInsertFilter({ group: "all", course: "all", stage: "all" });
          setCefr({})
          Modal.success({
            title: "등록 완료",
            okText: "확인",
            content: "정상적으로 등록되었습니다.",
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const insertOkNextHandler = async () => {
    const value = await formRef.current.validateFields();
    // console.log(value);
    const nextCode =
      "CH" +
      (
        "0000000" +
        String(parseInt(Number(value.code.split("CH")[1]) / 10) * 10 + 10)
      ).slice(-7);

    axios
      .post(`${backend}/contents/content_structure/chapter/insert`, { value })
      .then((data) => {
        if (data.status === 210) {
          Modal.error({
            style: { whiteSpace: "pre-line" },
            title: "에러",
            content: data.data.message,
            okText: "확인",
          });
        } else {
          getSourceData(data.data);
          setInsertPopup([true, nextCode]);
          Modal.success({
            afterClose: () => {
              formRef.current.resetFields();
              formRef.current.setFieldValue(
                "ContentCourseGroup_code",
                value.ContentCourseGroup_code
              );
              formRef.current.setFieldValue(
                "ContentCourse_code",
                value.ContentCourse_code
              );
              formRef.current.setFieldValue(
                "ContentStage_code",
                value.ContentStage_code
              );
              setInsertFilter({
                group: value.ContentCourseGroup_code,
                course: value.ContentCourse_code,
                stage: value.ContentStage_code
              });
              setCodeDisible(true);
            },
            title: "등록 완료",
            okText: "확인",
            content: "정상적으로 등록되었습니다.",
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실피",
            okText: "확인",
            content:
              "정상적으로 등록되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const deleteHandler = (_) => {
    const code = _.code;
    const count = _.count;

    if (count !== 0) {
      Modal.error({
        style: { whiteSpace: "pre-line" },
        title: "에러",
        content:
          "선택한 챕터코드에는 유닛이 등록되어 있습니다. \n해당하는 유닛을 먼저 삭제하세요.",
        okText: "확인",
      });
    } else {
      editCancelHandlerRight();
      axios
        .post(`${backend}/contents/content_structure/chapter/delete`, { code })
        .then((data) => {
          if (data.status === 210) {
            Modal.error({
              style: { whiteSpace: "pre-line" },
              title: "에러",
              content: data.data.message,
              okText: "확인",
            });
          } else {
            Modal.success({
              afterClose: () => {
                getSourceData(data.data);
              },
              style: { whiteSpace: "pre-line" },
              title: "삭제완료",
              content: "정상적으로 삭제되었습니다.",
              okText: "확인",
            });
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            navigate("/auth");
          } else {
            console.log(err);
            Modal.error({
              title: "삭제 실피",
              okText: "확인",
              content:
                "정상적으로 삭제되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
            });
          }
        });
    }
  };

  const resetValue = () => {
    const nowNum = formRef.current.getFieldValue(["num"]);
    const value = sourceDataKor[nowNum];
    formRef.current.setFieldsValue(sourceDataKor[nowNum]); // 리셋을 초기값으로 하지 않고 변경된 현재 데이터로 하기 위함
    setInsertFilter({
      group: value.ContentCourseGroup_code,
      course: value.ContentCourse_code,
      stage: value.ContentStage_code
    });
  };

  const editOkHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .post(`${backend}/contents/content_structure/chapter/edit`, { value })
      .then((data) => {
        // console.log(data);
        getSourceData(data.data);
        // setSourceData(data.data.data);
        setEditPopup([false, {}]);
        setInsertFilter({ group: "all", course: "all", stage: "all" });
        setPreNext([false, false]);
        setRowIndex(null);
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        }
        console.log(err);
        Modal.error({
          style: { whiteSpace: "pre-line" },
          title: "수정 실피",
          okText: "확인",
          content:
            "정상적으로 수정되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
        });
      });
  };

  const editCancelHandler = () => {
    setEditPopup([false, {}]);
    setInsertFilter({ group: "all", course: "all", stage: "all" });
    setPreNext([false, false]);
    setRowIndex(null);
  };

  // 이전 버튼 클릭 시 작동 함수
  const preRecord = () => {
    const nowNum = formRef.current.getFieldValue(["num"]);
    const max = sourceDataKor.length - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setPreNext([false, false]);
    }
    if (preNum === 0) {
      setPreNext([true, false]);
    }

    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    formRef.current.resetFields();
    formRef.current.setFieldsValue(sourceDataKor[preNum]);
    setInsertFilter({
      group: sourceDataKor[preNum].ContentCourseGroup_code,
      course: sourceDataKor[preNum].ContentCourse_code,
      stage: sourceDataKor[preNum].ContentStage_code,
    });
    setEditPopup([true, sourceDataKor[preNum]]);
  };

  // 다음 버튼 클릭 시 작동 함수
  const nextRecord = () => {
    const nowNum = formRef.current.getFieldValue(["num"]);
    const max = sourceDataKor.length - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setPreNext([false, false]);
    }
    if (nextNum === max) {
      setPreNext([false, true]);
    }

    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);
    formRef.current.resetFields();
    formRef.current.setFieldsValue(sourceDataKor[nextNum]);
    setInsertFilter({
      group: sourceDataKor[nextNum].ContentCourseGroup_code,
      course: sourceDataKor[nextNum].ContentCourse_code,
      stage: sourceDataKor[nextNum].ContentStage_code,
    });
    setEditPopup([true, sourceDataKor[nextNum]]);
  };

  // 형식명칭 validator 함수
  const nameValidator = (_, value) => {
    const code = formRef.current.getFieldValue("code");
    for (let i = 0; i < sourceDataKor.length; i++) {
      if (
        code !== sourceDataKor[i].code &&
        value &&
        value === sourceDataKor[i].name
      ) {
        return Promise.reject(
          new Error(`동일한 그룹명칭(한국어) "${value}"이 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  };

  const onRow = (record, rowIdx) => {
    return {
      onClick: () => {
        const data = fixLanguage ? sourceDataNative : sourceDataKor;
        const plusNum =
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize;
        const idx = plusNum + rowIdx;

        if (data.length === 1) {
          setRightBoxPreNext([true, true]);
        } else if (idx === 0) {
          setRightBoxPreNext([true, false]);
        } else if (idx === data.length - 1) {
          setRightBoxPreNext([false, true]);
        } else {
          setRightBoxPreNext([false, false]);
        }
        setRowIndex(rowIdx);
        setCurLanguage(data[idx].SystemSettingLanguage_code);
        setRightBox([true, data[idx]]);
        if (rightBox[0]) {
          rightFormRef.current.setFieldsValue(data[idx]);
        }
      },
    };
  };

  // 여기서부터 오른쪽 영역의 수정박스부분 -------------------------------

  const rightFormNameValidator = (_, value) => {
    const { code, SystemSettingLanguage_code } =
      rightFormRef.current.getFieldsValue();
    const data =
      SystemSettingLanguage_code === "L0010" ? sourceDataKor : sourceDataNative;

    for (let i = 0; i < data.length; i++) {
      if (code !== data[i].code && value && value === data[i].name) {
        return Promise.reject(
          new Error(`동일한 그룹명칭 "${value}"이 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  };

  const resetValueRight = () => {
    const nowNum = rightFormRef.current.getFieldValue(["num"]);
    rightFormRef.current.setFieldsValue(sourceDataNative[nowNum]); // 리셋을 초기값으로 하지 않고 변경된 현재 데이터로 하기 위함
  };

  const editOkHandlerRight = async () => {
    setConfirmLoading(true)
    const value = await rightFormRef.current.validateFields();
    // console.log(value);
    axios
    .post(`${backend}/contents/content_structure/chapter/edit`, { value })
    .then((data) => {
      // console.log(data);
      getSourceData(data.data);
      setConfirmLoading(false)
      
      Modal.success({
        title: "수정 완료",
        okText: "확인",
        content: "정상적으로 수정되었습니다.",
      });
    })
    .catch((err) => {
        setConfirmLoading(false)
        if (err.response.status === 401) {
          navigate("/auth");
        }
        console.log(err);
      });
  };

  const editCancelHandlerRight = () => {
    setRightBox([false, {}]);
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  };

  // // 이전 버튼 클릭 시 작동 함수
  const preRecordRight = () => {
    const data = fixLanguage ? sourceDataNative : sourceDataKor;
    const nowNum = rightFormRef.current.getFieldValue(["num"]);
    const max = data.length - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setRightBoxPreNext([false, false]);
    }
    if (preNum === 0) {
      setRightBoxPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    setCurLanguage(data[preNum].SystemSettingLanguage_code);
    setRightBox([true, data[preNum]]);
    if (rightBox[0]) {
      rightFormRef.current.resetFields();
      rightFormRef.current.setFieldsValue(data[preNum]);
    }
  };

  // 다음 버튼 클릭 시 작동 함수
  const nextRecordRight = () => {
    const data = fixLanguage ? sourceDataNative : sourceDataKor;
    const nowNum = rightFormRef.current.getFieldValue(["num"]);
    const max = data.length - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setRightBoxPreNext([false, false]);
    }
    if (nextNum === max) {
      setRightBoxPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);
    setCurLanguage(data[nextNum].SystemSettingLanguage_code);
    setRightBox([true, data[nextNum]]);
    if (rightBox[0]) {
      rightFormRef.current.resetFields();
      rightFormRef.current.setFieldsValue(data[nextNum]);
    }
  };
  
  const cefrChangerByTable = (e,record)=>{
    setRightBox([false,{}])
    const label = e.nativeEvent.target.labels[0].classList[e.nativeEvent.target.labels[0].classList.length-1]
    const checked = e.target.checked ? "Y" : "N"
    const newData = JSON.parse(JSON.stringify(sourceDataKor))
    newData[record.num][label] = checked
    setSourceDataKor(newData)
    const code = record.code
    axios
    .post(`${backend}/contents/content_structure/chapter/edit_checked`, {code, label, checked })
    .then(data=>{
    })
    .catch(err=>{
      console.log(err)
      if (err.response.status === 401) {
        navigate("/auth");
      }
      Modal.error({
        afterClose:()=>{
          setSourceDataKor(sourceDataKor)},
        title:"에러",
        content:"서버문제로 수정사항이 반영되지 않았습니다. 다시 시도하세요."
      })
      
    })
  }

  useEffect(() => {
    axios
      .get(`${backend}/contents/content_structure/chapter/group`)
      .then((data) => {
        const groupList = data.data.data[0].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const courseList = data.data.data[1].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const stageList = data.data.data[2].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });

        setGroups(groupList);
        setCourses(courseList);
        setStages(stageList)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        }
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${backend}/contents/content_structure/chapter/read`)
      .then((data) => {
        getSourceData(data);
        setLoading(false);
      })
      .then((data) => {
        if (rightBox[0]) {
          const num = rightFormRef.current.getFieldValue(["num"]);
          setRightBox([true, sourceDataNative[num]]);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, [curLanguage, filter]);

  useEffect(() => {
    if (rightBox[0]) {
      const num = rightFormRef.current.getFieldValue("num");
      // console.log(num)
      // console.log(sourceDataNative)
      rightFormRef.current.setFieldsValue(sourceDataNative[num]);
    }
  }, [sourceDataNative]);

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"100%", overflow: "auto" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ minWidth: "100px", textAlign: "left" }}>챕터 목록</span>
        <Space wrap>
          <Select
            options={[{ value: "all", label: "그룹: 전체" }, ...groups]}
            style={{ width: 200, textAlign: "left" }}
            defaultValue="all"
            value={filter.group}
            onChange={groupFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "코스: 전체" },
              ...courses.filter(
                (el) => filter.group === "all" || filter.group === el.group_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={filter.group === "all"}
            defaultValue="all"
            value={filter.course}
            onChange={courseFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "스테이지: 전체" },
              ...stages.filter(
                (el) => filter.course === "all" || filter.course === el.course_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={filter.course === "all"}
            defaultValue="all"
            value={filter.stage}
            onChange={stageFilter}
          ></Select>
          <Button onClick={insertHandler}>
            <PlusOutlined />
            챕터 등록
          </Button>
          <Button onClick={() => {
            setCodesControll([true, false])
            setInsertFilter(filter)
            }}>
            <PlusOutlined />
            챕터 일괄생성
          </Button>
          <Button
            onClick={() => {
              setCodesControll([false, true]);
              setInsertFilter(filter)
            }}
          >
            <MinusOutlined />
            챕터 일괄삭제
          </Button>
        </Space>
      </div>
      <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
        <Modal
          destroyOnClose={true}
          open={codesControll[0]}
          title="챕터 일괄등록"
          maskClosable={false}
          onCancel={()=>{
            setCodesControll([false, false]);
            formRef.current.resetFields();
            setInsertFilter({ group: "all", course: "all", stage: "all" });
          }}
          footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  formRef.current.resetFields();
                  setInsertFilter(filter)
                }}
              >
                내용 초기화
              </Button>
              <span>
                <Button
                  type="primary"
                  onClick={insertCodes}
                  icon={<CheckOutlined />}
                >
                  일괄생성
                </Button>
                <Button
                  onClick={() => {
                    setCodesControll([false, false]);
                    formRef.current.resetFields();
                    setInsertFilter({ group: "all", course: "all", stage: "all" });
                  }}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          }
        >
          <Form
            ref={formRef}
            layout="vertical"
            initialValues={{
              ContentCourseGroup_code: filter.group === "all" ? "그룹 선택" : filter.group,
              ContentCourse_code: filter.course === "all" ? "코스 선택" : filter.course,
              ContentStage_code: filter.stage === "all" ? "스테이지 선택" : filter.stage
            }}
          >
            <Form.Item
              name="ContentCourseGroup_code"
              label="그룹"
              required={true}
              rules={[
                {
                  required: true,
                  message: "그룹은 필수값입니다.",
                },
                {
                  validator: (_, record) =>
                    record === "그룹 선택"
                      ? Promise.reject(new Error("그룹을 선택하세요"))
                      : Promise.resolve(),
                },
              ]}
            >
              <Select
                options={groups}
                value={insertFilter.group}
                onChange={(value) => {
                  setInsertFilter({
                    ...insertFilter,
                    group: value,
                    course: "all",
                    stage: "all"
                  });
                  formRef.current.setFieldsValue({
                    ContentCourse_code: "코스 선택",
                    ContentStage_code: "스테이지 선택"
                  })
                }}
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentCourse_code"
              label="코스"
              required={true}
              rules={[
                {
                  required: true,
                  message: "코스는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "코스 선택"
                      ? Promise.reject(new Error("코스를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={courses.filter(
                  (el) =>
                    insertFilter.group === "all" ||
                    insertFilter.group === el.group_code
                )}
                disabled={insertFilter.group === "all"}
                value={insertFilter.course}
                onChange={(value) =>{
                  setInsertFilter({ ...insertFilter, course: value, stage: "all" })
                  formRef.current.setFieldsValue({
                    ContentStage_code: "스테이지 선택"
                  })
                }
                }
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentStage_code"
              label="스테이지"
              required={true}
              rules={[
                {
                  required: true,
                  message: "스테이지는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "스테이지 선택"
                      ? Promise.reject(new Error("스테이지를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={stages.filter(
                  (el) =>
                    insertFilter.course === "all" ||
                    insertFilter.course === el.course_code
                )}
                disabled={insertFilter.course === "all"}
                value={insertFilter.stage}
                onChange={(value) =>{
                  setInsertFilter({ ...insertFilter, stage: value })
                }
                }
              ></Select>
            </Form.Item>

            <Form.Item
              name="num"
              label="코드 갯수"
              required={true}
              rules={[
                { required: true, message: "코드 갯수는 필수값입니다." },
                {
                  pattern: /^[1-9]{1}$|^[1-9]{1}[0-9]{1}$|^100$/,
                  message: "1~100 까지의 숫자만 가능합니다.",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Space
              style={{ whiteSpace: "pre-line" }}
            >{`챕터가 등록되어 있지 않은 스테이지에만 챕터코드를 일괄생성할 수 있습니다. 이에, 챕터코드를 일괄생성하기 위하여는 기존에 등록되어 있는 챕터를 먼저 삭제해야 합니다. 
            
            챕터코드 일괄생성시 챕터 제목은 ‘Chapter CH0000010’ 형식으로 부여됩니다.
            `}</Space>
          </Form>
        </Modal>

        <Modal
          destroyOnClose={true}
          open={codesControll[1]}
          title="챕터 일괄삭제"
          maskClosable={false}
          onCancel={()=>{
            setCodesControll([false, false]);
            formRef.current.resetFields();
            setInsertFilter({ group: "all", course: "all", stage: "all" });
          }}
          footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  formRef.current.resetFields();
                  setInsertFilter(filter);
                }}
              >
                내용 초기화
              </Button>
              <span>
                <Button
                  type="primary"
                  onClick={deleteCodes}
                  icon={<CheckOutlined />}
                >
                  일괄삭제
                </Button>
                <Button
                  onClick={() => {
                    setCodesControll([false, false]);
                    formRef.current.resetFields();
                    setInsertFilter({ group: "all", course: "all", stage: "all" });
                  }}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          }
        >
          <Form
            ref={formRef}
            layout="vertical"
            initialValues={{
              ContentCourseGroup_code: filter.group === "all" ? "그룹 선택" : filter.group,
              ContentCourse_code: filter.course === "all" ? "코스 선택" : filter.course,
              ContentStage_code: filter.stage === "all" ? "스테이지 선택" : filter.stage
            }}
          >
            <Form.Item
              name="ContentCourseGroup_code"
              label="그룹"
              required={true}
              rules={[
                {
                  required: true,
                  message: "그룹은 필수값입니다.",
                },
                {
                  validator: (_, record) =>
                    record === "그룹 선택"
                      ? Promise.reject(new Error("그룹을 선택하세요"))
                      : Promise.resolve(),
                },
              ]}
            >
              <Select
                options={groups}
                value={insertFilter.group}
                onChange={(value) => {
                  setInsertFilter({
                    ...insertFilter,
                    group: value,
                    course: "all",
                    stage: "all"
                  });
                  formRef.current.setFieldsValue({
                    ContentCourse_code: "코스 선택",
                    ContentStage_code: "스테이지 선택"
                  })
                }}
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentCourse_code"
              label="코스"
              required={true}
              rules={[
                {
                  required: true,
                  message: "코스는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "코스 선택"
                      ? Promise.reject(new Error("코스를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={courses.filter(
                  (el) =>
                    insertFilter.group === "all" ||
                    insertFilter.group === el.group_code
                )}
                disabled={insertFilter.group === "all"}
                value={insertFilter.course}
                onChange={(value) =>{
                  setInsertFilter({ ...insertFilter, course: value, stage: "all" })
                  formRef.current.setFieldsValue({
                    ContentStage_code: "스테이지 선택"
                  })
                }
                }
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentStage_code"
              label="스테이지"
              required={true}
              rules={[
                {
                  required: true,
                  message: "스테이지는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "스테이지 선택"
                      ? Promise.reject(new Error("스테이지를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={stages.filter(
                  (el) =>
                    insertFilter.course === "all" ||
                    insertFilter.course === el.course_code
                )}
                disabled={insertFilter.course === "all"}
                value={insertFilter.stage}
                onChange={(value) =>{
                  setInsertFilter({ ...insertFilter, stage: value })
                }
                }
              ></Select>
            </Form.Item>

            <Space
              style={{ whiteSpace: "pre-line" }}
            >{`선택한 스테이지에 해당하는 챕터가 일괄 삭제됩니다. 다만, 챕터에 등록된 유닛이 없어야 삭제가 가능합니다. 이에, 챕터코드를 일괄삭제하기 위하여는 기존에 등록되어 있는 유닛을 먼저 삭제해야 합니다.`}</Space>
          </Form>
        </Modal>

        <Modal
          destroyOnClose={true}
          open={insertPopup[0]}
          title="챕터 등록"
          maskClosable={false}
          onCancel={()=>{
            setInsertPopup([false, ""]);
            formRef.current.resetFields();
            setInsertFilter({ group: "all", course: "all", stage: "all" });
            setCefr({})
          }}
          footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  formRef.current.resetFields();
                  setInsertFilter(filter);
                  setCefr({})
                }}
              >
                내용 초기화
              </Button>
              <span>
                <Button
                  type="primary"
                  onClick={insertOkHandler}
                  icon={<CheckOutlined />}
                >
                  등록
                </Button>
                <Button onClick={insertOkNextHandler} icon={<CheckOutlined />}>
                  등록 후 계속
                </Button>
                <Button
                  onClick={() => {
                    setInsertPopup([false, ""]);
                    formRef.current.resetFields();
                    setInsertFilter({ group: "all", course: "all", stage: "all" });
                    setCefr({})
                  }}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          }
        >
          <Form
            ref={formRef}
            layout="vertical"
            initialValues={{
              code: insertPopup[1],
              SystemSettingLanguage_code: "L0010",
              ContentCourseGroup_code: filter.group === "all" ? "그룹 선택" : filter.group,
              ContentCourse_code: filter.course === "all" ? "코스 선택" : filter.course,
              ContentStage_code: filter.stage === "all" ? "스테이지 선택" : filter.stage,
              delete_yn: "N",
              learning_points: null,
              cefr_a1_yn: "N",
              cefr_a2_yn: "N",
              cefr_b1_yn: "N",
              cefr_b2_yn: "N",
              cefr_c1_yn: "N",
              cefr_c2_yn: "N",
            }}
          >
            <Form.Item
              name="ContentCourseGroup_code"
              label="그룹"
              required={true}
              rules={[
                {
                  required: true,
                  message: "그룹은 필수값입니다.",
                },
                {
                  validator: (_, record) =>
                    record === "그룹 선택"
                      ? Promise.reject(new Error("그룹을 선택하세요"))
                      : Promise.resolve(),
                },
              ]}
            >
              <Select
                options={groups}
                value={insertFilter.group}
                onChange={(value) => {
                  setInsertFilter({
                    ...insertFilter,
                    group: value,
                    course: "all",
                    stage: "all"
                  });
                  formRef.current.setFieldsValue({
                    ContentCourse_code: "코스 선택",
                    ContentStage_code: "스테이지 선택"
                  })
                }}
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentCourse_code"
              label="코스"
              required={true}
              rules={[
                {
                  required: true,
                  message: "코스는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "코스 선택"
                      ? Promise.reject(new Error("코스를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={courses.filter(
                  (el) =>
                    insertFilter.group === "all" ||
                    insertFilter.group === el.group_code
                )}
                disabled={insertFilter.group === "all"}
                value={insertFilter.course}
                onChange={(value) =>{
                  setInsertFilter({ ...insertFilter, course: value, stage: "all" })
                  formRef.current.setFieldsValue({
                    ContentStage_code: "스테이지 선택"
                  })
                  setCefr(courses.filter(ele => ele.value === value)[0])
                }
                }
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentStage_code"
              label="스테이지"
              required={true}
              rules={[
                {
                  required: true,
                  message: "스테이지는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "스테이지 선택"
                      ? Promise.reject(new Error("스테이지를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={stages.filter(
                  (el) =>
                    insertFilter.course === "all" ||
                    insertFilter.course === el.course_code
                )}
                disabled={insertFilter.course === "all"}
                value={insertFilter.stage}
                onChange={(value) =>{
                  setInsertFilter({ ...insertFilter, stage: value })
                }
                }
              ></Select>
            </Form.Item>

            <Form.Item
              name="code"
              label="챕터 코드"
              required={true}
              rules={[
                { required: true, message: "챕터코드는 필수값입니다." },
                {
                  pattern: /^\CH\d{7}$/,
                  message:
                    '챕터코드는 "CH"와 일곱자리숫자 형식이어야 합니다.',
                },
              ]}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Input
                  defaultValue={insertPopup[1]}
                  disabled={codeDisible}
                ></Input>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={(e) => {
                    setCodeDisible(!codeDisible);
                  }}
                >
                  수정
                </Button>
              </div>
            </Form.Item>
            <Form.Item name="delete_yn" label="삭제 여부" hidden={true}>
              <Input disabled={true}></Input>
            </Form.Item>
            <Form.Item
              name="SystemSettingLanguage_code"
              label="언어코드"
              hidden={true}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              name="name"
              label="챕터 제목(한국어)"
              required={true}
              rules={[
                { required: true, message: "필수 입력사항 입니다." },
                // { validator: nameValidator },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Row>CEFR 등급</Row>
            <Row>
              <Col span={3}>
                <Form.Item name="cefr_a1_yn">
                  <Checkbox defaultChecked={false} onChange={cefrChanger} disabled={cefr.cefr_a1_yn === "Y" ? false : true}>
                    A1
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_a2_yn">
                  <Checkbox defaultChecked={false} onChange={cefrChanger} disabled={cefr.cefr_a2_yn === "Y" ? false : true}>
                    A2
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_b1_yn">
                  <Checkbox defaultChecked={false} onChange={cefrChanger} disabled={cefr.cefr_b1_yn === "Y" ? false : true}>
                    B1
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_b2_yn">
                  <Checkbox defaultChecked={false} onChange={cefrChanger} disabled={cefr.cefr_b2_yn === "Y" ? false : true}>
                    B2
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_c1_yn">
                  <Checkbox defaultChecked={false} onChange={cefrChanger} disabled={cefr.cefr_c1_yn=== "Y" ? false : true}>
                    C1
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_c2_yn">
                  <Checkbox defaultChecked={false} onChange={cefrChanger} disabled={cefr.cefr_c2_yn === "Y" ? false : true}>
                    C2
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item name="learning_points" label="챕터 학습요점(한국어)">
              <EditorComponent />
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          destroyOnClose={true}
          open={editPopup[0]}
          title="챕터 수정"
          maskClosable={false}
          onCancel={editCancelHandler}
          footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={resetValue}>내용 초기화</Button>
              <span>
                <Button
                  onClick={preRecord}
                  disabled={preNext[0]}
                  icon={<LeftOutlined />}
                >
                  이전
                </Button>
                <Button
                  type="primary"
                  onClick={editOkHandler}
                  icon={<CheckOutlined />}
                >
                  수정
                </Button>
                <Button
                  onClick={nextRecord}
                  disabled={preNext[1]}
                  icon={<RightOutlined />}
                >
                  다음
                </Button>
                <Button onClick={editCancelHandler} icon={<CloseOutlined />}>
                  취소
                </Button>
              </span>
            </div>
          }
        >
          <Form ref={formRef} layout="vertical" initialValues={editPopup[1]}>
            <Form.Item
              name="ContentCourseGroup_code"
              label="그룹"
              required={true}
              rules={[
                {
                  required: true,
                  message: "그룹은 필수값입니다.",
                },
                {
                  validator: (_, record) =>
                    record === "그룹 선택"
                      ? Promise.reject(new Error("그룹을 선택하세요"))
                      : Promise.resolve(),
                },
              ]}
            >
              <Select
                options={groups}
                value={insertFilter.group}
                onChange={(value) => {
                  setInsertFilter({
                    ...insertFilter,
                    group: value,
                    course: "all",
                    stage: "all"
                  });
                  formRef.current.setFieldValue(
                    "ContentCourse_code",
                    "코스 선택"
                  );
                  formRef.current.setFieldValue(
                    "ContentStage_code",
                    "스테이지 선택"
                  );
                }}
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentCourse_code"
              label="코스"
              required={true}
              rules={[
                {
                  required: true,
                  message: "코스는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "코스 선택"
                      ? Promise.reject(new Error("코스를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={courses.filter(
                  (el) =>
                    insertFilter.group === "all" ||
                    insertFilter.group === el.group_code
                )}
                value={insertFilter.course}
                onChange={(value) => {
                  setInsertFilter({ ...insertFilter, course: value, stage: "all" });
                  formRef.current.setFieldValue(
                    "ContentStage_code",
                    "스테이지 선택"
                  );
                }}
              ></Select>
            </Form.Item>

            <Form.Item
              name="ContentStage_code"
              label="스테이지"
              required={true}
              rules={[
                {
                  required: true,
                  message: "스테이지는 필수값입니다.",
                },
                {
                  validator: (_, record) => {
                    return record === "스테이지 선택"
                      ? Promise.reject(new Error("스테이지를 선택하세요"))
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                options={stages.filter(
                  (el) =>
                    insertFilter.course === "all" ||
                    insertFilter.course === el.course_code
                )}
                value={insertFilter.stage}
                onChange={(value) => {
                  setInsertFilter({ ...insertFilter, stage: value });
                }}
              ></Select>
            </Form.Item>

            <Form.Item
              name="code"
              label="챕터 코드"
              required={true}
              rules={[
                { required: true, message: "챕터코드는 필수값입니다." },
                {
                  pattern: /^\CH\d{7}$/,
                  message: '챕터코드는 "CH"와 일곱자리숫자 형식이어야 합니다.',
                },
              ]}
            >
              <Input disabled={true}></Input>
            </Form.Item>
            <Form.Item name="delete_yn" label="삭제 여부" hidden={true}>
              <Input disabled={true}></Input>
            </Form.Item>
            <Form.Item
              name="SystemSettingLanguage_code"
              label="언어코드"
              hidden={true}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              name="name"
              label="챕터 제목(한국어)"
              required={true}
              rules={[
                { required: true, message: "필수 입력사항 입니다." },
                // { validator: nameValidator },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Row>CEFR 등급</Row>
            <Row>
              <Col span={3}>
                <Form.Item name="cefr_a1_yn">
                  <Checkbox
                    checked={editPopup[1].cefr_a1_yn === "Y" ? true : false}
                    onChange={cefrChangerEdit}
                    disabled={editPopup[1].course_a1 === "Y" ? false : true}
                  >
                    A1
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_a2_yn">
                  <Checkbox
                    checked={editPopup[1].cefr_a2_yn === "Y" ? true : false}
                    onChange={cefrChangerEdit}
                    disabled={editPopup[1].course_a2 === "Y" ? false : true}
                  >
                    A2
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_b1_yn">
                  <Checkbox
                    checked={editPopup[1].cefr_b1_yn === "Y" ? true : false}
                    onChange={cefrChangerEdit}
                    disabled={editPopup[1].course_b1 === "Y" ? false : true}
                  >
                    B1
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_b2_yn">
                  <Checkbox
                    checked={editPopup[1].cefr_b2_yn === "Y" ? true : false}
                    onChange={cefrChangerEdit}
                    disabled={editPopup[1].course_b2 === "Y" ? false : true}
                  >
                    B2
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_c1_yn">
                  <Checkbox
                    checked={editPopup[1].cefr_c1_yn === "Y" ? true : false}
                    onChange={cefrChangerEdit}
                    disabled={editPopup[1].course_c1 === "Y" ? false : true}
                  >
                    C1
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item name="cefr_c2_yn">
                  <Checkbox
                    checked={editPopup[1].cefr_c2_yn === "Y" ? true : false}
                    onChange={cefrChangerEdit}
                    disabled={editPopup[1].course_c2 === "Y" ? false : true}
                  >
                    C2
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item name="learning_points" label="스테이지 학습요점(한국어)">
              <EditorComponent />
            </Form.Item>
          </Form>
        </Modal>

        <Col flex={1} style={{ minWidth: "100px" }}>
          <StyledTable
            className="pageTable"
            onRow={onRow}
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            columns={columns}
            rowKey="code"
            dataSource={sourceDataKor}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            scroll={{ x:100, y:"100%"}}
          />
        </Col>

        {rightBox[0] ? (
          <Spin spinning={confirmLoading}>
          <Col
            flex={0}
            style={{
              minWidth: "500px",
              border: "1px whitesmoke solid",
              marginLeft: "10px",
              height: "100%",
              overflow:"auto"
            }}
          >
            <div
              style={{
                padding: "10px",
                borderBottom: "1px whitesmoke solid",
                fontWeight: 700,
                fontSize: 17,
                textAlign: "left",
              }}
            >
              번역
            </div>
            <Layout.Content style={{ padding: "10px" }}>
              <Form
                ref={rightFormRef}
                layout="vertical"
                initialValues={rightBox[1]}
              >
                <Form.Item name="code" label="챕터 코드" hidden={true}>
                  <Input></Input>
                </Form.Item>

                <Form.Item
                  name="SystemSettingLanguage_code"
                  style={{ textAlign: "left" }}
                >
                  <Select
                    defaultValue={fixLanguage ? curLanguage : "L0010"}
                    value={curLanguage}
                    style={{
                      marginRight: "10px",
                      width: 120,
                      textAlign: "left",
                    }}
                    options={languageGroup}
                    onChange={(value) => {
                      setCurLanguage(value);
                    }}
                  />
                  <Checkbox
                    checked={fixLanguage}
                    onChange={(e) => {
                      setFixLanguage(e.target.checked);
                    }}
                  >
                    언어고정
                  </Checkbox>
                </Form.Item>

                <Form.Item
                  name="name"
                  label="챕터 제목"
                  style={{ textAlign: "left" }}
                  required={true}
                  rules={[
                    { required: true, message: "필수 입력사항 입니다." },
                    // { validator: rightFormNameValidator },
                  ]}
                >
                  <Input></Input>
                </Form.Item>
                <Form.Item name="learning_points" label="챕터 학습요점">
                  <EditorComponent />
                </Form.Item>
              </Form>
            </Layout.Content>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                borderTop: "1px whitesmoke solid",
              }}
            >
              <Button onClick={resetValueRight}>내용 초기화</Button>
              <span>
                <Button
                  onClick={preRecordRight}
                  disabled={rightBoxPreNext[0]}
                  icon={<LeftOutlined />}
                >
                  이전
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  type="primary"
                  onClick={editOkHandlerRight}
                  icon={<CheckOutlined />}
                >
                  수정
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={nextRecordRight}
                  disabled={rightBoxPreNext[1]}
                  icon={<RightOutlined />}
                >
                  다음
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={editCancelHandlerRight}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          </Col>
          </Spin>
        ) : null}
      </div>
    </div>
  );
}

export default Chapter;
